'use client'

import { toLoginPage } from '@/feature/account/services/account.routing'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { useRouter } from '@/lib/navigation/PageNavigation.client'
import { pushToGtmDataLayer } from '@/lib/tracking/services/tracking.gtm'
import { Drawer, DrawerAction, DrawerBody } from '@/ui/drawer/drawer/Drawer.client'
import { Icon } from '@/ui/icons/icon/Icon'
import { useAtom } from 'jotai'
import { useCallback } from 'react'
import { isSignedOutCartVisibleAtom } from '../../services/cart.store'

export function SignedOutCartDrawer(): React.ReactNode {
  const { t } = useTranslation(['signedOutCartDrawer'])
  const [isDrawerOpen, setIsDrawerOpen] = useAtom(isSignedOutCartVisibleAtom)
  const router = useRouter()

  const handleRedirect = useCallback(() => {
    setIsDrawerOpen(false)
    router.push(toLoginPage())
  }, [setIsDrawerOpen, router])

  return (
    <Drawer
      isOpen={isDrawerOpen}
      onOpenChange={setIsDrawerOpen}
      title={t('signedOutCartDrawer:title')}
    >
      <DrawerBody>
        <p>{t('signedOutCartDrawer:sub')}</p>
      </DrawerBody>
      <DrawerAction
        handle="log-in"
        type="custom"
        action={() => {
          handleRedirect()
          pushToGtmDataLayer({
            event: 'gaEvent',
            eventCategory: 'page panier déconnecté',
            eventAction: 'cta',
            eventLabel: 'connectez-vous',
          })
        }}
        variant="secondary"
        icon={<Icon.User />}
      >
        {t('signedOutCartDrawer:logIn')}
      </DrawerAction>
      <DrawerAction
        handle="create-account"
        type="custom"
        action={() => {
          handleRedirect()
          pushToGtmDataLayer({
            event: 'gaEvent',
            eventCategory: 'page panier déconnecté',
            eventAction: 'cta',
            eventLabel: 'créer un compte',
          })
        }}
        variant="primary"
        icon={<Icon.UserPlus />}
      >
        {t('signedOutCartDrawer:createAccount')}
      </DrawerAction>
    </Drawer>
  )
}
